import { render, staticRenderFns } from "./StudyInstituteAuditTrailView.vue?vue&type=template&id=0afe320a&scoped=true"
import script from "./StudyInstituteAuditTrailView.vue?vue&type=script&lang=ts"
export * from "./StudyInstituteAuditTrailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe320a",
  null
  
)

export default component.exports